<template>
  <base-modal modal-id="customTips">
    <template v-slot:header>
      <h4 class="modal-title mb-0">{{ _T('Custom tips') }}</h4>
    </template>
    <template v-slot:modal-body>
      <div class="tips-modal">
        <div class="input-part">
          {{ currency }}
          <input type="text" placeholder name v-model.number="tip" />
        </div>
        <div class="btns">
          <button type="button" class="btn btn-solid" @click="apply">
            {{ _T('Done') }}
          </button>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal'
import { mapGetters } from 'vuex'
export default {
  name: 'TipsModalBox',
  components: {
    BaseModal,
  },
  data () {
    return {
      tip: '',
    }
  },
  methods: {
    apply () {
      this.$bvModal.hide('customTips')
      this.$store.commit('SET_TIP', this.tip)
    },
  },
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
.modal-title {
  letter-spacing: 0.7px;
  font-weight: bold !important;
}
.tips-modal {
  .input-part {
    padding-bottom: $px40;
    text-align: center;

    ::placeholder {
      font-weight: bold;
      font-size: $px18;
      line-height: $px25;
      letter-spacing: 0.02em;
      color: $font-color;
    }

    input {
      width: $px155;
      text-align: center;
      height: $px40;
      border: none;
      border-bottom: $px2 solid $light-border;
      font-weight: bold;
      font-size: $px18;
      line-height: $px25;
      letter-spacing: 0.02em;
      color: $font-color;

      &:focus {
        outline: none;
      }
    }
  }
}
@media (max-width: 575px) {
  .customTips {
    box-shadow: 0px -$px6 $px30 rgba($black, 0.1);
    border-radius: $px12 $px12 0 0;
    position: fixed;
    left: 0;
    width: 100vw;
    bottom: 0;
    background-color: $white;
    z-index: 2;
    .title-part {
      padding: $px20;
      border-bottom: $px1 solid $light-border;
      display: flex;
      align-items: center;
      h4 {
        font-weight: 600;
        font-size: $px18;
        line-height: $px22;
        letter-spacing: 0.02em;
        color: $font-color;
        text-transform: capitalize;
        margin-bottom: 0;
      }
      .close-modal {
        margin-left: auto;
      }
    }
    .input-part {
      padding: $px100 0;
      text-align: center;
      ::placeholder {
        font-weight: bold;
        font-size: $px18;
        line-height: $px25;
        letter-spacing: 0.02em;
        color: $font-color;
      }
      input {
        width: $px155;
        text-align: center;
        height: $px40;
        border: none;
        border-bottom: $px2 solid $light-border;
        font-weight: bold;
        font-size: $px18;
        line-height: $px25;
        letter-spacing: 0.02em;
        color: $font-color;
        &:focus {
          outline: none;
        }
      }
    }
  }
  .overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(var(--color-font-color-source), 0.8);
    z-index: 1;
  }
  &.show {
    display: block;
  }
}
.tips {
  label {
    cursor: pointer;
    display: grid;
    margin: 0;
    padding: 0;
    input {
      &[type='radio'] {
        opacity: 0;
        height: $px1;
      }
    }
  }
}
.body-rtl {
  .tips-modal {
    .btns {
      text-align: right !important;
    }
  }
}
</style>
